import { Injectable } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SiteService } from '../services/site.service';
import { Site } from '../models/site/site';

@Injectable({
  providedIn: 'root',
})
export class InjectCurrentSiteInterceptorService implements HttpInterceptor {
  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly siteService: SiteService,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (req.url.startsWith(environment.BASE_URL_API)) {
      const accessToken = this.authenticationService.getAccessToken();
      const site: Site = this.siteService.currentSiteSelected();

      let headersConfig: { [header: string]: string } = {};

      if (accessToken) {
        headersConfig['Authorization'] = `Bearer ${accessToken}`;
      }

      const siteIdentifier = site?.id || site?.nom || site?.name;
      const siteName = site?.nom || site?.name || '';

      if (siteIdentifier) {
        headersConfig['X-Site-Selected'] = siteIdentifier.toString();
        headersConfig['X-Site-Selected-Name'] = encodeURIComponent(siteName);
      }

      req = req.clone({
        setHeaders: headersConfig,
      });
    }

    return next.handle(req);
  }
}
